export const euiSelectObjectFromValue = value => ({ text: value, value })
